// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__2cVZH","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2lN8K"};